import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import React, { Component } from 'react';
import swcPrimaryLogo from 'assets/swc-primary-logo.png';
import 'styles/header.scss';
export default class Header extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            sticky: false,
        };
        this._handleScroll = () => {
            const style = window.getComputedStyle(this.refs.mobile);
            const displayStyle = style.getPropertyValue('display');
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            const compare = displayStyle === 'block' ? 0 : 30;
            if (scrollTop > compare && !this.state.sticky) {
                this.setState({ sticky: true });
            }
            else if (scrollTop <= compare && this.state.sticky) {
                this.setState({ sticky: false });
            }
        };
    }
    render() {
        return (_jsxs("header", { className: classnames('header', this.props.className, {
                'is-light': this.props.light,
                'is-light-mobile': this.props.lightMobile,
                'is-sticky': this.state.sticky,
            }), children: [_jsx("div", { className: "only-mobile", ref: "mobile" }), _jsx("div", { className: "header__content", children: _jsx("div", { className: "header__logo", children: _jsx("a", { href: "/", children: _jsx("img", { src: swcPrimaryLogo }) }) }) })] }));
    }
}
